import React from 'react';

import EditableText from 'components/shared/EditableText';

import s from './index.module.css';
import { ILocationProps } from './types';
import Wrapper from './Wrapper';

function Location({ value, canEdit = false, onEdit, readOnly }: ILocationProps) {
  if (readOnly && !value) return null;

  if (canEdit) {
    const handleChange = (enteredValue: string) => {
      const obj = { location: enteredValue || ' ' };
      onEdit(obj);
    };

    return (
      <Wrapper>
        <span className={s.editValue}>
          <EditableText text={value} onChange={handleChange} placeholder="Location" isReadonly={readOnly} />
        </span>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <span data-block>{value}</span>
    </Wrapper>
  );
}

export default Location;
